import Typography from '@mui/material/Typography';
import { Icon, IconName } from '@packages/shared-ui';
import Button, {
  ButtonSize,
  ButtonVariant,
} from '@packages/shared-ui/v4/button';
import type { FormEvent } from 'react';
import CheckoutFormFields from './CheckoutFormFields';
import CheckoutOrderSummary from './CheckoutOrderSummary';
import useStyles from './CheckoutView.styles';
import type { OrderSummary } from './checkoutOrderSummaryData';

interface Props {
  orderSummary: OrderSummary;
  onBack: () => void;
  onPlaceOrder?: () => void;
}

export default function CheckoutView({
  orderSummary,
  onBack,
  onPlaceOrder,
}: Props) {
  const { classes } = useStyles();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onPlaceOrder?.();
  };

  return (
    <>
      <div className={classes.header}>
        <Button
          variant={ButtonVariant.GHOST}
          iconName={IconName.ARROW_LEFT}
          aria-label='Back'
          className={classes.backButton}
          onClick={onBack}
        />
        <Typography variant='h2' component='h1'>
          Review your order
        </Typography>
      </div>
      <form className={classes.layout} onSubmit={handleSubmit}>
        <div className={classes.summary}>
          <CheckoutOrderSummary orderSummary={orderSummary} />
        </div>
        <div className={classes.fields}>
          <CheckoutFormFields />
        </div>
        <div className={classes.actions}>
          <Button
            type='submit'
            size={{ xs: ButtonSize.SM, md: ButtonSize.MD }}
            fullWidth
          >
            Place order
          </Button>
          <aside className={classes.contact}>
            <Icon name={IconName.CALL} width={32} aria-hidden />
            <div className={classes.contactContent}>
              <Typography variant='h5' component='h2'>
                Have questions for us?
              </Typography>
              <Typography variant='bodyMd' color='semantic.text.secondary'>
                <span className={classes.contactLink}>
                  Have one of our specialists help you design the right system
                  for your needs.
                </span>{' '}
                We can walk you through choices and help you pick the right
                battery for your needs.
              </Typography>
            </div>
          </aside>
        </div>
      </form>
    </>
  );
}
